import d3 from 'd3'

export default class IntegratedChart {
  constructor (el, dataObj, xMinIX, xMaxIX) {
    this.el = el
    this.dataObj = dataObj
    this.xMinIX = xMinIX
    this.xMaxIX = xMaxIX
  }

  draw () {
    var svg = d3.select(this.el)
    var dataObj = this.dataObj
    var margin = {top: 22, right: 20, bottom: 30, left: 50}
    var width = 730
    var height = 300
    var xMaxIX = this.xMaxIX
    var xMinIX = this.xMinIX

    /*
      height degeri 4'e ve 5'e tam bolunebilmeli
      height / 4 = bir grafigin yuksekligi (500 icin 125)
      bir grafigin yuksekligi / 5 = stroke-dasharray pattern'inda ==> 0, X-1, 1, 0; (125 icin 0, 24, 1, 0) */

    svg
      .attr('width', width + margin.left + margin.right)
      .attr('height', height + margin.top + margin.bottom)

    var g = svg.append('g').attr('transform', 'translate(' + margin.left + ',' + margin.top + ')')

    var panes = 4
    var paneHeight = height / panes
    var x = d3.time.scale().rangeRound([0, width])

    x.domain([dataObj.Sample[this.xMinIX], dataObj.Sample[this.xMaxIX]])

    var formatTime = d3.time.format('%M:%S') // d3.timeFormat('%M:%S')
    var formatMinutes = function (d) { return formatTime(new Date(d)) }

    // var y1 = d3.scaleLinear()
    var y1 = d3.scale.linear()
      .rangeRound([paneHeight, 0])
      .clamp(true)
    var line1 = d3.svg.line() // d3.line()
      .defined(function (d, i) { return (i >= xMinIX) && (i <= xMaxIX) })
      .x(function (d, i) { return x(i * dataObj.Interval) })
      .y(function (d) { return y1(d) })
    y1.domain([0, 100])
    g.append('g')
    // .call(d3.axisLeft(y1))
      .attr('class', 'axis axis--y')
      .call(d3.svg.axis().scale(y1).orient('left').tickValues([0, 100]))
      .append('text')
      .attr('fill', '#000')
      .attr('transform', 'rotate(-90)')
      .attr('y', -6)
      .attr('dy', '-0.6em')
      .attr('dx', '-2.0em')
      .attr('text-anchor', 'end')
      .text('Pves')
    g.append('path')
      .datum(dataObj['Pves (1)']) // Buradaki data undefined ise bu hata geliyor ==> "Uncaught TypeError: Cannot read property 'length' of undefined"
      .attr('fill', 'none')
      .attr('stroke', '#0000A8')
    // .attr("stroke-linejoin", "miter")
    // .attr("stroke-linecap", "butt")
      .attr('stroke-width', 1.0)
      .attr('shape-rendering', 'crispEdges')
      .attr('d', line1)
      .select('text').remove()

    g.append('g')
      .attr('transform', 'translate(0,' + (paneHeight) + ')')
    // .call(d3.axisBottom(x).ticks(0))
      .call(d3.svg.axis().scale(x).ticks(0))

    // var y2 = d3.scaleLinear()
    var y2 = d3.scale.linear()
      .rangeRound([paneHeight * 2, paneHeight])
      .clamp(true)
    y2.domain([0, 100]) // d3.max(dataObj['Pabd_(2)'])
    var line2 = d3.svg.line() // d3.line()
      .defined(function (d, i) { return (i >= xMinIX) && (i <= xMaxIX) })
      .x(function (d, i) { return x(i * dataObj.Interval) })
      .y(function (d) { return y2(d) })
    g.append('g')
    // .call(d3.axisLeft(y2))
      .attr('class', 'axis axis--y')
      .call(d3.svg.axis().scale(y2).orient('left').tickValues([0, 100]))
      .append('text')
      .attr('fill', '#000')
      .attr('transform', 'rotate(-90)')
      .attr('y', -6)
      .attr('dy', '-0.6em')
      .attr('dx', '-10.0em')
      .attr('text-anchor', 'end')
      .text('Pabd')

    g.append('path')
      .datum(dataObj['Pabd (2)'])
      .attr('fill', 'none')
      .attr('stroke', '#A80101')
    // .attr("stroke-linejoin", "miter")
    // .attr("stroke-linecap", "butt")
      .attr('stroke-width', 1.0)
      .attr('shape-rendering', 'crispEdges')
      .attr('d', line2)

    g.append('g')
      .attr('transform', 'translate(0,' + (paneHeight * 2) + ')')
    // .call(d3.axisBottom(x).ticks(0))
      .call(d3.svg.axis().scale(x).ticks(0))

    // var y3 = d3.scaleLinear()
    var y3 = d3.scale.linear()
      .rangeRound([paneHeight * 3, paneHeight * 2])
      .clamp(true)
    y3.domain([0, 100])
    var line3 = d3.svg.line() // d3.line()
      .defined(function (d, i) { return (i >= xMinIX) && (i <= xMaxIX) })
      .x(function (d, i) { return x(i * dataObj.Interval) })
      .y(function (d, i) { return y3(dataObj['Pves (1)'][i] - dataObj['Pabd (2)'][i]) })
    g.append('g')
    // .call(d3.axisLeft(y3))
      .attr('class', 'axis axis--y')
      .call(d3.svg.axis().scale(y3).orient('left').tickValues([0, 100]))
      .append('text')
      .attr('fill', '#000')
      .attr('transform', 'rotate(-90)')
      .attr('y', -6)
      .attr('dy', '-0.6em')
      .attr('dx', '-18.0em')
      .attr('text-anchor', 'end')
      .text('Pdet')
    g.append('path')
      .datum(dataObj['Sample#']) // data not used here
      .attr('fill', 'none')
      .attr('stroke', '#56C5C5')
    // .attr("stroke-linejoin", "miter")
    // .attr("stroke-linecap", "butt")
      .attr('stroke-width', 1.0)
      .attr('shape-rendering', 'crispEdges')
      .attr('d', line3)

    g.append('g')
      .attr('transform', 'translate(0,' + (paneHeight * 3) + ')')
    // .call(d3.axisBottom(x).ticks(0))
      .call(d3.svg.axis().scale(x).ticks(0))

    // var y4 = d3.scaleLinear()
    var y4 = d3.scale.linear()
      .rangeRound([paneHeight * 4, paneHeight * 3])
      .clamp(true)
    y4.domain([0, 50])
    var line4 = d3.svg.line() // d3.line()
      .defined(function (d, i) { return (i >= xMinIX) && (i <= xMaxIX) })
      .x(function (d, i) { return x(i * dataObj.Interval) })
      .y(function (d) { return y4(d) })
    g.append('g')
    // .call(d3.axisLeft(y4))
      .attr('class', 'axis axis--y')
      .call(d3.svg.axis().scale(y4).orient('left').tickValues([0, 50]))
      .append('text')
      .attr('fill', '#000')
      .attr('transform', 'rotate(-90)')
      .attr('y', -6)
      .attr('dy', '-0.6em')
      .attr('dx', '-26.0em')
      .attr('text-anchor', 'end')
      .text('Qura')
    g.append('path')
      .datum(dataObj['Qura'])
      .attr('fill', 'none')
      .attr('stroke', '#56C556')
    // .attr("stroke-linejoin", "miter")
    // .attr("stroke-linecap", "butt")
      .attr('stroke-width', 1.0)
      .attr('shape-rendering', 'crispEdges')
      .attr('d', line4)

    g.append('g')
      .attr('class', 'axis axis--x')
      .attr('transform', 'translate(0,' + (height) + ')')
    // .call(d3.axisBottom(x).ticks(d3.timeMinute.every(1)).tickSizeInner(-height).tickFormat(formatMinutes))
      .call(d3.svg.axis().scale(x).ticks(d3.time.minutes, 1).innerTickSize(-height).tickFormat(formatMinutes))
    /* .attr('stroke', '#000')
          .attr('opacity', '0.4')
          .attr('stroke-dasharray', '0, ' + ((height / 20) - 1) + ', 1, 0')
          .attr('stroke-width', 2)
          .attr('stroke-linecap', 'square') */
  }
}



// WEBPACK FOOTER //
// ./src/IntegratedChart.js